import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import {
  Box,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { DatePicker, TimePicker, DateTimePicker } from "@mui/x-date-pickers";

const Frequency=({scheduleData, setScheduleData, isPublished})=> {

  const [frequency, setFrequency] = useState(scheduleData?.frequency);
  const [dayName, setDayName] = useState(scheduleData?.dayName);
  const [hourlyVal, setHourlyVal] = useState(scheduleData?.hourlyVal);
  const [loadType, setLoadType] = useState(scheduleData?.loadType);
  const [scheduleTime, setScheduleTime] = useState(scheduleData?.scheduleTime);
  const [firstExcecutionTime, setFirstExcecutionTime] = useState(scheduleData?.firstExcecutionTime);
  
  const frequencyArr = ["Hourly", "Daily", "Weekly"];
  const hourlyArr = ["Every Half Hour", "Every Hour", "Every Two Hour", "Every Four Hour", "Every Six Hour", "Every Eight Hour", "Every Twelve Hour"];
  const daysOfWeekArr = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const handleFequencyChange = (e)=>{
    setFrequency(e.target.value);
  }

  console.log("scheduleData::", JSON.stringify(scheduleData));
  console.log("scheduleTime", scheduleTime);

  useEffect(()=>{
    const obj = { frequency: frequency, dayName: dayName, hourlyVal: hourlyVal, loadType: loadType, scheduleTime: scheduleTime, firstExcecutionTime: firstExcecutionTime };
    setScheduleData(obj);
  },[frequency, dayName, hourlyVal, loadType, scheduleTime, firstExcecutionTime]);

  const firstExTime= (firstExcecutionTime || scheduleData?.firstExcecutionTime);
  return (
    <LocalizationProvider >
      <Box sx={{bgcolor: "white"}} >
        {/* Frequency */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Typography variant='' color='textPrimary'>Frequency</Typography>
          <Select
            disabled={isPublished}
            value={frequency || scheduleData?.frequency}
            label=""
            onChange={(e) => handleFequencyChange(e)}
          >
            {
                frequencyArr?.map((fr)=>{
                    return (<MenuItem value={fr}>{fr}</MenuItem>);
                    
                })
            }
          </Select>
        </FormControl>

        {/* Schedule Run Day/Date */}
        {frequency!=="Daily" && (
            <FormControl fullWidth sx={{ mb: 2 }}>
                
                {(frequency || scheduleData?.frequency)==="Hourly" && (
                    <>
                        <Typography variant='' color='textPrimary'>{"Schedule Run Hour"}</Typography>
                        <Select value={hourlyVal || scheduleData?.hourlyVal} label="" onChange={(e) => setHourlyVal(e.target.value)} disabled={isPublished} >
                        {
                            hourlyArr?.map((hour)=>{
                                return (<MenuItem value={hour}>{hour}</MenuItem>);
                                
                            })
                        }
                        </Select>
                    </>
                    
                )}
                {(frequency || scheduleData?.frequency)==="Weekly" && (
                    <>
                        <Typography variant='' color='textPrimary'>{"Schedule Run Day"}</Typography>
                        <Select value={dayName || scheduleData?.dayName} label="" onChange={(e) => setDayName(e.target.value)} disabled={isPublished}>
                        {
                            daysOfWeekArr?.map((day)=>{
                                return (<MenuItem value={day}>{day}</MenuItem>);
                                
                            })
                        }
                        </Select>
                    </>
                    
                )}
            </FormControl>
        )}
        
        {/* Schedule Run Time */}
        {(frequency || scheduleData?.frequency)!=="Hourly" && (
            <FormControl fullWidth sx={{ mb: 2 }}>
                <Typography variant='' color='textPrimary'>Schedule Run Time</Typography>
                <TimePicker
                value={Date.parse(scheduleTime || scheduleData?.scheduleTime)}
                disabled={isPublished}
                label=""
                onChange={(newValue) => setScheduleTime(newValue)}
                renderInput={(params) => <TextField fullWidth sx={{ mb: 2 }} {...params} />}
                />
            </FormControl>
        )}
        

        {/* Load Type */}
        <FormControl fullWidth sx={{ mb: 2 }}>
            <Typography variant='' color='textPrimary'>Load Type</Typography>
            <Select
                disabled={isPublished}
                value={loadType || scheduleData?.loadType}
                label=""
                onChange={(e) => setLoadType(e.target.value)}
            >
                <MenuItem value="Full">Full</MenuItem>
                <MenuItem value="Delta">Delta</MenuItem>
            </Select>
        </FormControl>

        {/* First Excecution Time */}
        <FormControl fullWidth sx={{ mb: 2 }}>
            <Typography variant='' color='textPrimary'>First Excecution Time</Typography>
            <DateTimePicker
            value={Date.parse(firstExTime)}
            disabled={isPublished}
            label=""
            onChange={(newValue) => setFirstExcecutionTime(newValue)}
            />
        </FormControl>
      </Box>
    </LocalizationProvider>
  );
}

export default Frequency;
